import { Routes } from '@angular/router';
import { scoreboardAdminGuard } from '../../core/guards';

export const statkeeperRoutes: Routes = [
  {
    path: 'statkeeper/match/:matchId',
    loadComponent: () =>
      import('./pages/statkeeper/statkeeper.component').then((m) => m.StatKeeperComponent),
    canActivate: [scoreboardAdminGuard],
  },
];
